import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import QAPI from "qapi";

import "lightgallery.js/dist/css/lightgallery.css";

window.QAPI = QAPI;
ReactDOM.render(<App />, document.getElementById("root"));
